import { Component, EventEmitter, Input, Output } from '@angular/core';
import { defaultTheme } from 'src/app/theme/theme';

@Component({
    selector: 'app-tag-menu',
    templateUrl: './tag-menu.component.html',
    styleUrls: ['./tag-menu.component.scss'],
    standalone: false
})
export class TagMenuComponent {
  @Input()
  theme = defaultTheme;

  @Input()
  labels: string[];

  @Input()
  selectedIndex: number;

  @Output()
  clickMenu = new EventEmitter<number>();

  get selectedStyle() {
    return {
      'background-color': this.theme.primaryColor,
      border: `2px solid transparent`,
      color: '#fff'
    };
  }

  get unselectedStyle() {
    return {
      border: `2px solid ${this.theme.primaryLightColor}`
    };
  }

  clickItem(index: number) {
    this.clickMenu.emit(index);
  }
}
